import React, { useState } from 'react'
import { IItemModel } from './ItemsApp'
import PageHeadSection from '../admin/components/PageHeadSection'
import { QRCodeSVG } from 'qrcode.react'
import { Checkbox, FormControlLabel, TextField } from '@mui/material'
import SectionBoxContainer from '../../components/SectionBoxContainer'

interface IProps {
    items: IItemModel[],
    goBack: () => void
}

export default function PrintQrCodes(props: IProps) {

    const { items, goBack } = props

    const [showUniqueId, setShowUniqueId] = useState<boolean>(true)
    const [showTitle, setShowTitle] = useState<boolean>(true)
    const [showSn, setShowSn] = useState<boolean>(true)
    const [boxWidth, setBoxWidth] = useState<number>(40)
    const [uniqueIdFontSize, setUniqueIdFontSize] = useState<number>(11)
    const [titleFontSize, setTitleFontSize] = useState<number>(11)
    const [snFontSize, setSnFontSize] = useState<number>(11)

    return(
        <div className="print-selected-items-qr-codes-page-container">
            <div className="content-of-print-selected-items-qr-codes-page-container">

                <PageHeadSection pageName="items" customTitle="Print Qr Codes" customActionButtons={[
                    {
                        icon: "print",
                        label: "Print",
                        onClick: () => window.print()
                    }
                ]} hideBreadcrumbs triggerBack={goBack} />

                <div className="print-selected-items-form-container">
                    <div style={{ height: 35 }}></div>
                    <SectionBoxContainer>
                        <TextField variant="outlined" label="Box Width (mm)" fullWidth value={boxWidth} onChange={(e) => setBoxWidth(Number(e.target.value))} style={{ marginBottom: 15 }} />
                        <TextField variant="outlined" label="Unique ID font size (px)" fullWidth value={uniqueIdFontSize} onChange={(e) => setUniqueIdFontSize(Number(e.target.value))} style={{ marginBottom: 15 }} />
                        <TextField variant="outlined" label="Title font size (px)" fullWidth value={titleFontSize} onChange={(e) => setTitleFontSize(Number(e.target.value))} style={{ marginBottom: 15 }} />
                        <TextField variant="outlined" label="SN font size (px)" fullWidth value={snFontSize} onChange={(e) => setSnFontSize(Number(e.target.value))} style={{ marginBottom: 15 }} />

                        <FormControlLabel control={<Checkbox checked={showUniqueId} onChange={(e) => setShowUniqueId(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />} label="Show Unqiue ID" />
                        <FormControlLabel control={<Checkbox checked={showTitle} onChange={(e) => setShowTitle(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />} label="Show Title" />
                        <FormControlLabel control={<Checkbox checked={showSn} onChange={(e) => setShowSn(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />} label="Show Serial Number" />

                    </SectionBoxContainer>
                </div>

                <div className="print-selected-items-page-container">
                    <div className="a4-page-modal-container hidden-for-pdf">

                        <div className="a4-page-container items-export">
                            <div className="content-of-content-of-a4-page-container">
                                
                                <div className="printable-qr-codes">
                                    {items.map((item, index: number) => {

                                        return(
                                            <div className="printed-qr-code-box" key={index} style={{ width: `${boxWidth}mm` }}>
                                                <div className="content-of-printed-qr-code-box">
                                                    <QRCodeSVG value={item.unique_id} size={125} level="H" />
                                                    {showUniqueId && <h3 style={{ fontSize: `${uniqueIdFontSize}px` }}>{item.unique_id}</h3>}
                                                    {showSn && <p style={{ fontSize: `${snFontSize}px` }}><span className="bold-text">SN:</span> {item.serial_number ? item.serial_number : "-"}</p>                                                }
                                                    {showTitle &&  <p style={{ fontSize: `${titleFontSize}px` }} className="item-title">{item.title}</p>}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}